import React, { memo } from 'react'
import PropTypes from 'prop-types'

// components
import { RangeTab, SectionSearch } from '../../../../../shared'
import { Button, Select, Toolbar, ToolbarRow } from '../../../../../index'
import { HISTORICAL_QUARTER, HOLDER, THEMES } from '../../../../../../utils'

const propTypes = {
  dataId: PropTypes.string.isRequired,
  toolbarTheme: PropTypes.oneOf([THEMES.STEEL, THEMES.Q4_BLUE]),
  toolTheme: PropTypes.oneOf([THEMES.Q4_BLUE, THEMES.INK]),
  noData: PropTypes.bool,
  quarters: PropTypes.number,
  search: PropTypes.string,
  holderType: PropTypes.string.isRequired,
  onHolderChange: PropTypes.func.isRequired,
  onQueryChange: PropTypes.func.isRequired,
  onExport: PropTypes.func.isRequired,
  listOptions: PropTypes.shape({
    page: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired
  }).isRequired,
}

const defaultProps = {
  toolbarTheme: THEMES.Q4_BLUE,
  toolTheme: THEMES.INK,
  quarters: 4
}

/**
 * Historical Holder Toolbar Component
 * @param props
 */
function HistoricalHolderToolbar (props) {
  const {
    dataId, toolbarTheme, toolTheme, noData, quarters, search, holderType,
    onHolderChange, onQueryChange, onExport, exporting, listOptions
  } = props
  const handleSearchChange = (search) => onQueryChange({ search })
  const handleQuarterChange = (option) => option && onQueryChange({
    quarters: option.value,
    listOptions: { ...listOptions, sortBy: undefined, sortDir: undefined }
  })

  return (
    <Toolbar theme={toolbarTheme}>
      <ToolbarRow justified>
        <div className='toolbar_group toolbar_group--spaced'>
          <RangeTab
            theme={toolTheme}
            buttons={HOLDER.map((option) => ({
              ...option,
              dataId: `${dataId}${option.dataId}`,
              active: holderType === option.value,
              onClick: (event, value) => onHolderChange(value)
            }))}
          />
          <Select
            theme={toolTheme}
            dataId={{
              inputId: `${dataId}QuarterFilterInput`,
              menuId: `${dataId}QuarterFilterMenu`
            }}
            size='thin'
            value={HISTORICAL_QUARTER.find((option) => option.value === quarters)}
            options={HISTORICAL_QUARTER}
            searchable={false}
            clearable={false}
            onChange={handleQuarterChange}
          />
        </div>
        <div className='toolbar_group'>
          <SectionSearch
            dataId={`${dataId}Search`}
            theme={toolTheme}
            value={search}
            onQueryChange={handleSearchChange}
            onClear={handleSearchChange}
          />
          <Button
            dataId={`${dataId}Export`}
            theme={toolTheme}
            loading={exporting}
            icon='q4i-download-4pt'
            label='Export'
            disabled={noData}
            onClick={onExport}
          />
        </div>
      </ToolbarRow>
    </Toolbar>
  )
}

HistoricalHolderToolbar.propTypes = propTypes
HistoricalHolderToolbar.defaultProps = defaultProps

export default memo(HistoricalHolderToolbar)
